let gettodayinfo = function () {
  var today = new Date();
  return [today.getFullYear(), today.getMonth(), today.getDate()];
}

//获取今天字符串
export function getTodayCustomDateStr() {
  let todayArr = gettodayinfo();
  let y = todayArr[0];
  let m = todayArr[1] + 1;
  let d = todayArr[2];
  return `${y}-${m}-${d}`
}

export function padLeftZero(str) {
  str += "";
  return ('00' + str).substr(str.length);
}

//获取某天字符串
export function getOneDayCustomDateStr(dateObj) {
  let y = dateObj.getFullYear()
  let m = padLeftZero(dateObj.getMonth() + 1)
  let d = padLeftZero(dateObj.getDate())
  
  let h = padLeftZero(dateObj.getHours())
  let mm = padLeftZero(dateObj.getMinutes())
  let ss = padLeftZero(dateObj.getSeconds())
  
  return `${y}-${m}-${d} ${h}:${mm}:${ss}`
}


// WEBPACK FOOTER //
// ./src/common/js/getToday.js